/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Metrics_Aria_LabelInputs */

const en_event_metrics_aria_label = /** @type {(inputs: Event_Metrics_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event metrics`)
};

const fr_event_metrics_aria_label = /** @type {(inputs: Event_Metrics_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metriques de l'evenement`)
};

const de_event_metrics_aria_label = /** @type {(inputs: Event_Metrics_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignismetriken`)
};

const it_event_metrics_aria_label = /** @type {(inputs: Event_Metrics_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metriche degli eventi`)
};

const ru_event_metrics_aria_label = /** @type {(inputs: Event_Metrics_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метрики событий`)
};

const es_event_metrics_aria_label = /** @type {(inputs: Event_Metrics_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métricas de eventos`)
};

const zh_cn2_event_metrics_aria_label = /** @type {(inputs: Event_Metrics_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件指标`)
};

const ja_event_metrics_aria_label = /** @type {(inputs: Event_Metrics_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントメトリクス`)
};

const hi_event_metrics_aria_label = /** @type {(inputs: Event_Metrics_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट मेट्रिक्स`)
};

const pt_pt2_event_metrics_aria_label = /** @type {(inputs: Event_Metrics_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métricas do evento`)
};

/**
* | output |
* | --- |
* | "Event metrics" |
*
* @param {Event_Metrics_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_aria_label = /** @type {((inputs?: Event_Metrics_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_metrics_aria_label(inputs)
	if (locale === "de") return de_event_metrics_aria_label(inputs)
	if (locale === "it") return it_event_metrics_aria_label(inputs)
	if (locale === "ru") return ru_event_metrics_aria_label(inputs)
	if (locale === "es") return es_event_metrics_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_metrics_aria_label(inputs)
	if (locale === "ja") return ja_event_metrics_aria_label(inputs)
	if (locale === "hi") return hi_event_metrics_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_metrics_aria_label(inputs)
	return en_event_metrics_aria_label(inputs)
});